import * as React from 'react';

export interface PathInfo
{
  caption: string | null;
  goToHandler?: (subPath: string, fullPath: string) => Promise<void>;
}

export class PathInfoMap
{
  private map = new Map<string, PathInfo | undefined>();

  public setPath(uniqueId: string, pathInfo: PathInfo | undefined)
  {
    this.map.set(uniqueId, pathInfo);
  }

  public getPath(uniqueId: string | null): string[]
  {
    const path: string[] = [];
    if (uniqueId !== null)
    {
      const parts = uniqueId.split('_');
      let subpath: string | undefined;
      for (const part of parts)
      {
        subpath = (subpath === undefined) ? part : `${subpath}_${part}`;
        const info = this.map.get(subpath);
        if (info && info.caption)
        {
          path.push(info.caption);
        }
      }
    }

    return path;
  }

  public async goToControl(uniqueId: string | null): Promise<void>
  {
    if (uniqueId !== null)
    {
      const parts = uniqueId.split('_');
      let subpath: string | undefined;
      let info: PathInfo | undefined;
      for (const part of parts)
      {
        subpath = (subpath === undefined) ? part : `${subpath}_${part}`;
        info = this.map.get(subpath);
        if (info && info.goToHandler)
        {
          await info.goToHandler(subpath, uniqueId);
        }
      }
      if (info && !info.goToHandler)
      {
        this.focusControl(uniqueId);
      }
    }
  }

  public focusControl(uniqueId: string): void
  {
    const el = document.getElementById(uniqueId);
    if (el && el.focus)
    {
      el.scrollIntoView({ block: 'center' });
      el.focus();
    }
  }

  public static assignPathInfo(uniqueId: string, pathInfo: string | PathInfo | undefined): JSX.Element
  {
    return (
      <ErrorContext.Consumer>
        {map =>
        {
          if (typeof pathInfo === 'string')
          {
            pathInfo = { caption: pathInfo };
          }
          map.setPath(uniqueId, pathInfo);
          return null;
        }
        }
      </ErrorContext.Consumer>
    );
  }

}

export const ErrorContext = React.createContext(new PathInfoMap());

export function usePathInfo()
{
  return React.useContext(ErrorContext);
}
